module.exports = __webpack_public_path__ + "media/images/plasma-8ffa8724c553fb8da1d5ca7c6fbe866d.jpg";